export default "__VITE_ASSET__CviTDIEL__"